import { COMPANY } from './config.js';
import { request, vendey, combo, unwrap } from './api.js';
import { saveSession } from './storage.js';
import { notifyEvent } from './notifications.js';
import { logService } from './logs.js';
import { catalogOptions } from './catalogs.js';
export async function loadLoginCatalogs() {
  const results = await Promise.all([
    vendey('spVNT_UserCajacsvweb', '1|1|'), vendey('spINV_ALMACENLISTACSVWEB', '1|1|'), vendey('spCTA_CAJACOMBOCSVWEB', '1|1|1|')
  ]);
  const users = combo(results[0]); const warehouses = catalogOptions(results[1], 'warehouses'); const boxes = combo(results[2]);
  if (!users.length || !warehouses.length || !boxes.length) throw new Error('No se recibieron todos los catálogos. Reintenta.');
  return { users, warehouses, boxes };
}
export async function login({ user, warehouse, box, password }) {
  if (!user || !warehouse || !box || !password) throw new Error('Completa usuario, contraseña, almacén y caja.');
  const response = await request('Vendey/Login', { usuario: user.name, password, vendedor: '', empresa: '', caja: box.id, almacen: '', token: COMPANY });
  if (response.Exito !== true) throw new Error('El servidor no confirmó el inicio de sesión.');
  const result = unwrap(response);
  if (!result?.gsNroCaja || !result?.gsUsuarioCaja) throw new Error('El login no devolvió una caja válida.');
  const session = { seller: user.name, sellerId: user.id, warehouseId: Number(warehouse.id), store: warehouse.name,
    boxName: box.name, boxId: result.gsNroCaja, boxUser: result.gsUsuarioCaja, boxSelectionId: box.id, priceListId: 1 };
  let outsideHours = false;
  try { outsideHours = (await notifyEvent('login', session))?.fueraDeHorario === true; }
  catch (error) { logService('Horario laboral', error.message); }
  if (outsideHours) throw new Error('No se puede iniciar sesión fuera del horario laboral configurado.');
  return saveSession(session);
}
